import React from "react";

export class ImpressumEN extends React.Component {
    render() {
        return (
            <>
                <h3>Responsible of the website</h3>
                <p>DH Healthcare GmbH</p>

                <h3>Registered office and registration</h3>
                <p>Bonn, District Court Bonn HRB 25633</p>

                <h3>Address and contact</h3>
                <p>
                    Konrad-Zuse-Platz 1-3
                    <br />
                    53227 Bonn, Germany
                </p>
                <p>
                    Telephone: +49 (0)228 / 2668 000
                    <br />
                    Fax: +49 (0) 228 / 2668 001
                    <br />
                    E-mail: healthcare.de@dedalus.com
                </p>

                <h3>Legal representatives</h3>
                <p>
                    Mr. Dieter Nels
                    <br />
                    Mr. Daniel Strauch
                    <br />
                    Mr. Winfried Post
                </p>
            </>
        );
    }
}
